import { Button } from "antd";
import Flex from "../../../components/Flex";

type OrderGroupFiltersProps = {
  groupFilters: string[];
  selectedGroupsFilters: string[];
  onGroupFilterChange: (groups: string[]) => void;
  onViewAll: () => void;
};

export function OrderGroupFilters({
  groupFilters,
  selectedGroupsFilters,
  onGroupFilterChange,
  onViewAll,
}: OrderGroupFiltersProps) {
  if (groupFilters.length === 0) return null;

  return (
    <Flex wrap="wrap" style={{ width: "100%" }} gap={5}>
      {groupFilters.map((group) => (
        <Button
          key={group}
          type={selectedGroupsFilters.includes(group) ? "primary" : "default"}
          onClick={() => {
            const newGroups = selectedGroupsFilters.includes(group)
              ? selectedGroupsFilters.filter((g) => g !== group)
              : [...selectedGroupsFilters, group];
            onGroupFilterChange(newGroups);
          }}
        >
          {group}
        </Button>
      ))}
      <Button shape="round" onClick={onViewAll}>
        View All/Reset
      </Button>
    </Flex>
  );
}
